export default {
  name: "FooterSection",
  data(){
    return({
      rights:{
        company_name: "BCX",
        year: new Date().getFullYear()
      }
    })
  },
  methods: {
    scroll_to_top() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
